export default "__VITE_ASSET__1ghRyyNI__"